import Vue from 'vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'ol/ol.css'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select/dist/vue-select.css'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import 'vue2-datepicker/locale/zh-cn'
import App from './App.vue'
import router from './router'
import * as Icons from "./utils/icons"
import * as Filters from "./filters/common"
import * as Ajax from './utils/ajax'
import Global from './utils/global'
import User from './services/user'
import vSelect from 'vue-select'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/default.css'

Vue.config.productionTip = false;
Vue.use(BootstrapVue);
Vue.use(BootstrapVueIcons);
Vue.component('v-select', vSelect);
Vue.component("vue-date-picker", DatePicker);
Vue.component("vue-slider", VueSlider);
void (Icons);
void (Filters);
void (Ajax);
if (window.location.pathname.startsWith("/vue/loading-vessel-map")) {
} else {
    User.refresh();
}

Global.app = new Vue({
    router,
    render: h => h(App)
}).$mount('#app');
